/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/NextAppointment/Content/Content/Content/Appointment/Time"
  
}) {
let upcomingAppointmentValueData = fromData.useDataFormat({ viewPath,
context: 'upcoming_appointment',
format: fromHelpers.formatTime,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="upcoming_appointment"
 format="helpers.js formatTime"
 text={upcomingAppointmentValueData}
 weight="medium"
 color={dtColorsNeutral600}
 marginRight={dtSpaceXxs}
 size="small"
 whiteSpace="nowrap"
/>
{children}
</React.Fragment>)
}